import { useContext } from "react";
import AuthContext from "./AuthContext";
import Loader from "../../utils/Loader/Loader";
import { useMediaQuery } from "@chakra-ui/react";
import DesktopBrowserRecommended from "./DesktopBrowserRecommended";
import { useLocation } from "react-router-dom";

const RedirectAuthenticated = ({ children }) => {
  const { isAuthenticated, isLoading, authUser } = useContext(AuthContext);
  const { pathname } = useLocation();
  const mobileViewAllowedRoutes = ["/register", "/verify-email", "/login", "/"];

  const [isSmallerThan800] = useMediaQuery("(max-width: 800px)");

  const userRoles = authUser?.roles || [];
  const isAgent = userRoles.includes("agent") && userRoles.length == 1;
  const redirectRoute = isAgent ? "/live-agent-chats" : "/dashboard";
  if (isSmallerThan800 && !mobileViewAllowedRoutes.includes(pathname)) {
    return <DesktopBrowserRecommended />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (isAuthenticated) {
    window.location.href = redirectRoute;
  } else {
    return children;
  }
};

export default RedirectAuthenticated;
